import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литературное чтение. 3 класс",
        subject: "Творческие задания как механизм преодоления трудностей младших школьников в создании текста",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Творческие задания как механизм преодоления трудностей младших школьников в создании текста",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Никитина Екатерина Евгеньевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории начального общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Одна из приоритетных целей изучения литературного чтения – это развитие творчества младших школьников: способности к самовыражению в устной и письменной речи, основанной на анализе и оценке текста. </p>"
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Организация творческой деятельности на основе авторского текста позволяет поднять уровень текстовой деятельности на принципиально новый уровень: отказаться от компиляции, следования образцу и подойти к самовыражению: оригинальности текста, передаче своего эмоционального отношения, богатство средств выразительности и др.  </p>
                                     `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Практические задания, направленные на анализ художественных произведений с позиции образности, изобразительно-выразительных средств речи, уместности их употребления, законов логики построения текста, последовательности его смысловых фрагментов, позволяют обучающимся овладеть приёмами создания собственного текста.</p>
                                   `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p style="text-indent: 2vw;">Самостоятельное создание описательного текста часто вызывает у обучающихся определённые трудности, связанные с процессом «рождения» и реализации замысла. Основные трудности представлены в таблице.</p>
                        <p style="text-align: center"><img src="images/lit_cont.png"></p>
                        <p style="text-indent: 2vw;">В данном методическом кейсе педагогам предлагается обсудить методику обучения младших школьников третьего класса созданию описательных текстов, которая предупреждает возникновение у детей трудностей.</p>
                        <p style="text-indent: 2vw;">Есть такое мнение учёных-методистов, что возникающие у школьников трудности при создании собственных сочинений – описательных текстов, возникают потому, что учитель предлагает методику, которая не соответствует характеру деятельности, которой должны заниматься дети.</p>
                        <p style="text-indent: 2vw;">Обратите внимание на особенности сочинительской деятельности:</p>
                        <p>
                            <ul>
                                <li>Сосредоточенность на теме</li>
                                <li>Оживление ассоциаций как раздумье о замысле</li>
                                <li>Отбор объектов для описания, значимых для автора</li>
                                <li>Передача авторского отношения к объектам</li>
                                <li>Выбор соответствующих выразительных средств – для привлечения читателя к тексту</li>
                                <li>Внимание к эпитетам, сравнениям, метафорам, гиперболам как средствам сделать образ ярким и привлекательным</li>
                            </ul>
                        </p>
                        <p style="text-indent: 2vw;">Методика обучения должна обеспечить умение детей представлять их в тексте.</p> `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральная образовательная программа начального общего образования. – Москва, 2023",
                "Уроки литературного чтения в современной начальной школе. Книга для учителя. / Под ред. Н.Ф. Виноградовой. – Москва: Российский учебник, 2019",
                "Виноградова Н.Ф. Цели и направления обновления Федерального государственного образовательного стандарта начального общего образования. / Начальное образование, 2022, № 4"
            ],
            sites: [
                "Реестр примерных основных общеобразовательных программ: https://fgosreestr.ru/poop/primerna",
                "Уроки литературного чтения. 3 класс. Книга для учителя: https://rosuchebnik.ru/material/uroki-literaturnogo-chteniy",
                "Сайт педагогов «Мультиурок». Методика работы над сочинениями разных видов в начальной школе: https://nsportal.ru/nachalnaya-shkola",
                "Российский образовательный портал: http://www.school.edu.ru",
                "Учимся писать сочинение. Учебники-онлайн: https://uchebniksonline.ru/uchebniki/3",
                "Сайт «Я иду на урок русского языка» и электронная версия газеты «Русский язык»: http://www.rus.1september.ru",
                "Журнал «Начальная школа»: www.openworld/school",
                "Газета «1 сентября». Методика работы над сочинением в начальной школе: https://urok.1sept.ru/",
                "Издательство «Просвещение»: http://www.prosv.ru/",
            ],
            filesToDownload: [
                {
                    link: "./files/work.pdf",
                    fileName: "Практическая работа «Моделирование в задачах процентного роста»"
                },
                {
                    link: "./files/examples.pdf",
                    fileName: "Примеры материалов по Информационному моделированию"
                }
            ]
        }
    ],
};
